export const CalendarCardSkeleton = () => {
    return (
        <div className="w-full">
            <div className="my-3 flex">
                <div className=" mr-4 mt-[36px] h-[50px] min-w-[50px] animate-pulse rounded-full bg-ash-dark dark:bg-dark-3 md:mr-1.5 md:h-8 md:min-w-[32px] "></div>
                <div className="h-[104px] w-full animate-pulse rounded-2xl bg-ash-dark dark:bg-dark-3 md:h-[80px] "></div>
            </div>
            <div className="my-3 flex">
                <div className=" mr-4 mt-[36px] h-[50px] min-w-[50px] animate-pulse rounded-full bg-ash-dark dark:bg-dark-3 md:mr-1.5 md:h-8 md:min-w-[32px] "></div>
                <div className="h-[104px] w-full animate-pulse rounded-2xl bg-ash-dark dark:bg-dark-3 md:h-[80px] "></div>
            </div>
            <div className="my-3 flex">
                <div className=" mr-4 mt-[36px] h-[50px] min-w-[50px] animate-pulse rounded-full bg-ash-dark dark:bg-dark-3 md:mr-1.5 md:h-8 md:min-w-[32px] "></div>
                <div className="h-[104px] w-full animate-pulse rounded-2xl bg-ash-dark dark:bg-dark-3 md:h-[80px] "></div>
            </div>
            <div className="my-3 flex">
                <div className=" mr-4 mt-[36px] h-[50px] min-w-[50px] animate-pulse rounded-full bg-ash-dark dark:bg-dark-3 md:mr-1.5 md:h-8 md:min-w-[32px] "></div>
                <div className="h-[104px] w-full animate-pulse rounded-2xl bg-ash-dark dark:bg-dark-3 md:h-[80px] "></div>
            </div>
            <div className="my-3 flex">
                <div className=" mr-4 mt-[36px] h-[50px] min-w-[50px] animate-pulse rounded-full bg-ash-dark dark:bg-dark-3 md:mr-1.5 md:h-8 md:min-w-[32px] "></div>
                <div className="h-[104px] w-full animate-pulse rounded-2xl bg-ash-dark dark:bg-dark-3 md:h-[80px] "></div>
            </div>
        </div>
    );
};
